import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { ComponentType } from 'react';
import { messages as en } from '../locales/en.po';
import { messages as ru } from '../locales/ru.po';
import { messages as pl } from '../locales/pl.po';

import { i18n as i18nLegacy } from './i18n-legacy';

export { LANGUAGES, type Lang, i18n } from './i18n-legacy';

i18n.load({ ru, en, pl });

i18n.activate(i18nLegacy.language);

i18nLegacy.on('languageChanged', (lng) => {
  i18n.activate(lng);
});

export function withTranslations<P extends object>(
  Component: ComponentType<P>
) {
  function WithTranslations(props: P) {
    return (
      <I18nProvider i18n={i18n}>
        <Component {...props} />
      </I18nProvider>
    );
  }
  WithTranslations.displayName = `withTranslations(${Component.displayName})`;
  return WithTranslations;
}
